import { supabase } from '../lib/supabase'

export const statusService = {
  schemaName: 'Tickets',
  tableName: 'status',

  // READ ALL
  async getAll() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error fetching statuses:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  /**
   * Estado con el que nace un ticket: el de menor id del catálogo.
   * @returns {Promise<{success: boolean, data: Object|null, error: string|undefined}>}
   */
  async getInitial() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('id')
        .order('id', { ascending: true })
        .limit(1)
        .maybeSingle()
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error fetching initial status:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  // READ ONE
  async getById(id) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
        .eq('id', id)
        .single()
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error fetching status:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  // CREATE
  async create(status) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .insert([status])
        .select()
        .single()
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error creating status:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  // UPDATE
  async update(id, updates) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .update(updates)
        .eq('id', id)
        .select()
        .single()
      if (error) throw error
      return { success: true, data }
    } catch (error) {
      console.error('Error updating status:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  // DELETE
  async delete(id) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .delete()
        .eq('id', id)
      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error deleting status:', error)
      return { success: false, error: error.message }
    }
  },
}
